import React from 'react'
import styles from './style/new_configuration_call_to_action_style.module.scss'
import washbasinBath from '../../../../assets/img/cut-to-size/washbasin-bath.png'
import LocalizedLink from '../../../global/LocalizedLink'
import Translation from '../../../global/Translation'

const NewConfigurationCallToAction = () => (
    <div className={styles['new-config-cta']}>
        <div className={styles['new-config-cta__overlay']}>
            <img
                src={washbasinBath}
                alt="Configurar nuevo producto"
                className={styles['new-config-cta__bg']}
            />
        </div>
        <LocalizedLink routeId="ROUTE_CUT_TO_SIZE" queryString="" params={{ outlet: '' }} gtmLabel="saved-custom-drafts_card_new-configuration">
            <button className={styles['new-config-cta__btn']}>
                <Translation id={"configure_new_product"} defaultMessage={"Configure new product"} />
                <span className={styles['new-config-cta__icon']}>
                    <i className="fa fa-plus" aria-hidden="true"></i>
                </span>
            </button>
        </LocalizedLink>
    </div>
)

export default NewConfigurationCallToAction